export enum AnswerStatus {
  Correct = "correct",
  PartiallyCorrect = "partially-correct",
  Wrong = "wrong",
  WrongLess = "wrong-less",
  WrongMore = "wrong-more",
}
